import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Divider, Stack, Badge } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import {
  SearchIcon,
  DeleteIcon,
  CloudOffIcon,
} from "../../../Resources/Icons/icons";
import UpdateLoginStatus from "./UpdateLoginStatus";

import {
  GetPolicyList,
  DeleteBranch,
  GetCompany,
  GetPolicyFileById,
  FilterPolicyList,
  ReframeEndDateTimeFormat,
  GetPolicyFindbyId,
} from "../../../Service/_index";
import moment from "moment";
import { DatePicker } from "antd";
import Autocomplete from "@mui/material/Autocomplete";
import Loader from "../../../UiComponents/Loader/Loader";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import Dialog from "@mui/material/Dialog";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  return data.policyNumber ? "file_link" : null;
};

const headCells = [
  {
    id: "policyListName",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registerationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  // {
  //   id: "action",
  //   placeMent: false,
  //   disablePadding: false,
  //   label: "Action",
  // },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const LogStatus = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [selectedPending, setSelectedPending] = useState("Pending");
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("");
  const [FilteredData, setFilteredData] = useState([]);
  const [modifiedHeadCell, setModifiedHeadCell] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    isView: false,
    isEdit: true,
    isDelete: false,
    isSearch: true,
    isApprove: false,
  });
  const [searchText, setSearchText] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const SearchFilteredData = FilteredData.filter((el) => {
    return `${el?.policyListName},${el?.companyName},${el?.policyNumber},${el?.customerName},${el?.registerationNumber},${el?.paymentMode},${el.email}`
      .toLowerCase()
      .includes(searchText.trim().toLowerCase());
  });
  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const clientId = sessionStorage.getItem("clientID");

  const GetData = () => {
    GetPolicyList({ logStatus: true }).then((res) => {
      // console.log(clientId,res.data)

      setPolicyList(res?.data);
    });
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const DeleteFunction = async () => {
    await DeleteBranch(selectedData?._id)
      .then((res) => {
        GetData();
        setOpenConfirmBox(false);
        ToastError(res.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el.companyId?.shortName},${el.policyNumber},${el.customerName
              },,${el.registrationNumber},${el.paymentMode},${el.userId?.email
              } ,${moment(el?.issueDate).format("D-M-Y")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res?.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  React.useEffect(() => {
    GetCompanyDetails();
  }, []);

  const UpdateLoginIdFunction = (row) => {
    // GetPolicyFindbyId(row?._id).then((res)=>{
    //   console.log(res?.data);
    // })
    setSelectedData(row);
    setOpenDrawer(true);
  };

  const OpenPolicyFile = (row, showLoader = true, callback) => {
    // console.log("open policy file: ", row);

    if (showLoader) setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        if (showLoader) setOpenLoader(false);
        if (callback) callback();
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        if (showLoader) setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      })
      .catch((err) => {
        if (showLoader) setOpenLoader(false);
        if (callback) callback();
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  useEffect(() => {
    setFilteredData(
      policyList.map((data) => ({
        _id: data?._id,
        policyNumber: data?.policyNumber,
        customerName: data?.customerName,
        paymentMode: data?.paymentMode,
        email: data?.userId?.email,
        registerationNumber: data?.registrationNumber,
        companyName: data?.companyId?.shortName,
        policyListName: moment(data?.issueDate).format("D-M-Y"),
        data: data,
      }))
    );
  }, [policyList]);

  const FilterData = async (overrides = {}) => {
    const currentCompany = overrides.hasOwnProperty("companyId")
      ? overrides.companyId
      : selectedCompany;
    const currentStartDate = overrides.hasOwnProperty("startDate")
      ? overrides.startDate
      : selectedStartDate;
    const currentEndDate = overrides.hasOwnProperty("endDate")
      ? overrides.endDate
      : selectedEndDate;
    const currentPolicyNumber = overrides.hasOwnProperty("policyNumber")
      ? overrides.policyNumber
      : selectedPolicyNumber;

    // If all filters are empty, fetch default data
    if (!currentCompany && !currentStartDate && !currentEndDate && !currentPolicyNumber) {
      GetData();
      return;
    }

    let endDate = null;
    if (currentEndDate) {
      endDate = await ReframeEndDateTimeFormat(currentEndDate); // it represent end date
    }

    setOpenLoader(true);
    FilterPolicyList({
      companyId: currentCompany,
      startDate: currentStartDate, // it represent start date
      endDate: endDate, // it represent end date
      policyNumber: currentPolicyNumber?.toUpperCase(),
      logStatus: true,
    })
      .then((res) => {
        setPolicyList(res?.data);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const handleClearAllState = () => {
    setSelectedPolicyNumber("");
    setSelectedCompany(null);
    setSelectedPending("Pending");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRange([new Date(), new Date()]);
    // Fetch all data without filters
    GetData();
  };

  const handleClearSingleFilter = (filterId) => {
    let overrides = {};
    if (filterId === 1) {
      setSelectedPolicyNumber("");
      overrides.policyNumber = "";
    } else if (filterId === 2) {
      setSelectedCompany(null);
      overrides.companyId = null;
    } else if (filterId === 3) {
      setSelectedPending("Pending");
    } else if (filterId === 4) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      overrides.startDate = null;
      overrides.endDate = null;
    }
    // Fetch data with the cleared filter override
    FilterData(overrides);
  };

  const handleSaveAllFilter = () => {
    // console.log(selectedTab, selectedUser, ".../...");
    // console.log("function calling...")
    FilterData();
  };
  const filterBoxData = [
    {
      id: 1,
      label: "Policy Number",
      // data: userDetails,
      setState: (e) => {
        setSelectedPolicyNumber(e.toUpperCase().trim());
      },
      value: selectedPolicyNumber,
      type: "normalInput",
    },
    {
      id: 2,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Pending",
      data: [{ value: "Pending", label: "Pending", _id: "Pending" }],
      setState: setSelectedPending,
      value: selectedPending,
      type: "input",
      variation: "single",
      defaultValue: "Pending",
    },
    {
      id: 4,
      label: "Select Date",
      setDate: (e) => {
        const newStartDate = e ? e[0] : null;
        const newEndDate = e ? e[1] : null;

        setSelectedStartDate(newStartDate);
        setSelectedEndDate(newEndDate);
        FilterData({
          startDate: newStartDate,
          endDate: newEndDate
        });
      },
      type: "noDefaultDate",
    },

    // {
    //   id: 5,
    //   label: "Select Date",
    //   setDate: setDateRange,
    //   type: "date",
    // },
  ];
  const activeFiltersCount = [
    selectedPolicyNumber || null,
    selectedCompany || null,
    //selectedPending !== "Pending" ? selectedPending : null,
    selectedPending || null,
    selectedStartDate && selectedEndDate ? 1 : 0,
  ].filter(Boolean).length;

  // console.log("filtered Data: box ", filterBoxData)
  // console.log("selected policy number: ", selectedPolicyNumber)
  // console.log("from logStatus: ", dateRange)
  return (
    <>
      {/* <Grid container spacing={2} sx={{ padding: "10px 10px 0 10px" }}>
        <Grid item sm={3} xs={12}>
          <TextField
            className="textField w-100"
            placeholder="Policy Number"
            sx={{ color: "black", background: "white" }}
            onChange={(e) => setSelectedPolicyNumber(e.target.value)}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <FloatLabel label="Select Company" value={selectedCompany}>
            <Autocomplete
              name="companyId"
              className="AutoComplete_InputBox"
              options={companyDetails}
              onChange={(e, v) => setSelectedCompany(v?._id)}
              renderInput={(params) => <TextField {...params} />}
              isOptionEqualToValue={(option, value) =>
                option?._id === value._id
              }
            />
          </FloatLabel>
        </Grid>
        <Grid item sm={3} xs={12}>
          <FloatLabel label="Start date & End Date" value="react">
            <RangePicker
              placement="bottomLeft"
              className="Range_Picker w-100"
              style={{ borderRadius: "0px" }}
              onChange={(e) => {
                setSelectedStartDate(e ? e[0].$d : null);
                setSelectedEndDate(e ? e[1].$d : null);
              }}
              format="DD/MM/YYYY"
            />
          </FloatLabel>
        </Grid>
        <Grid item sm={3} xs={12}>
          <FloatLabel label="Pending" value={selectedPending}>
            <Autocomplete
              name="companyId"
              className="AutoComplete_InputBox"
              options={[{ value: "Pending", label: "Pending", _id: "Pending" }]}
              onChange={(e) => setSelectedPending(e.target.value)}
              renderInput={(params) => <TextField {...params} />}
              isOptionEqualToValue={(option, value) =>
                option?._id === value._id
              }
            />
          </FloatLabel>
        </Grid>
        <Grid item sm={9} xs={12} />
        <Grid
          item
          sm={3}
          xs={12}
          sx={{ display: "flex", justifyContent: "end" }}
        >
          <Button
            className="Common_Button"
            sx={{ width: { xs: "100%", sm: "30%" } }}
            onClick={FilterData}
          >
            Search
          </Button>
        </Grid>
      </Grid> */}
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    Log Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    sx={{
                      "& .filter-box-container": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                      "& .MuiPaper-root": {
                        boxShadow: "none",
                        border: "none",
                        p: 0,
                      },
                    }}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>

              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} />
                <Grid item xs={12} sm={4} md={3.1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search  "
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={SearchFilteredData}
                columns={headCells}
                handleEdit={UpdateLoginIdFunction}
                handleOnClickBehaviour={OpenPolicyFile}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
                paginationReset={searchText}
              />
            </Grid>
          </Box>
        </Box>
      </div>

      <Dialog
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "50%" } },
        }}
      >
        {openDrawer ? (
          <UpdateLoginStatus
            setOpenDrawer={setOpenDrawer}
            selectedData={selectedData.data}
            formType={selectedData?._id ? "edit" : "add"}
            GetActiveData={FilterData}
            handleOnClickBehaviour={OpenPolicyFile}
          />
        ) : null}
      </Dialog>

      <ConfirmBox
        open={openConfirmBox}
        title={"Delete"}
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton={"Delete"}
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
      />
      {/* <Loader open={openLoader} /> */}
    </>
  );
};
export default LogStatus;
